import SecurityIcon from '@mui/icons-material/Security';
import CspmDetailBody from '../CspmDetailBody';

// Descriptor for the CSPM engine. Future engines add a sibling file with the
// same shape and register in registry.js.
export const cspmEngine = {
  id: 'cspm',
  label: 'Security Hub CSPM',
  color: '#4698D3',
  Icon: SecurityIcon,
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND — EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  // Sidebar sub-items. They hang directly off the SECURITY HUB group —
  // there is no "Detection engines" grouping in PortalSidebar.
  nav: [
    { label: 'Summary', to: '/securityhub/cspm' },
    { label: 'Security standards', to: '/securityhub/cspm/standards' },
    { label: 'Findings', to: '/securityhub/cspm/findings' },
    { label: 'Enrollment', to: '/securityhub/cspm/enrollment' },
    { label: 'Settings', to: '/securityhub/cspm/settings' },
  ],
  enableRoute: '/securityhub/cspm', // where "Enable/Configure" routes
  DetailBody: CspmDetailBody,
};
